import React, { createContext, useContext, useEffect, useState } from 'react';
import bridge from './bridge';

const NetworkContext = createContext({ online: true, type: 'unknown' });

export function NetworkGate({ children }) {
  const [state, setState] = useState({ online: true, type: 'unknown' });
  useEffect(() => {
    let active = true;
    bridge.call('network.status').then((s) => { if (active) setState(s); }).catch(() => {});
    bridge.call('network.subscribe').catch(() => {});
    const off = bridge.on('network.changed', (p) => { if (active) setState(p); });
    return () => { active = false; off(); };
  }, []);
  return <NetworkContext.Provider value={state}>{children}</NetworkContext.Provider>;
}

export function useNetwork() { return useContext(NetworkContext); }
